module.exports = require("live/services/registry");